import React from 'react';
import { getProfileToDisplay } from 'reducer/profileRedux';
import { useSelector } from 'react-redux';
import { useIsEnrolledUser } from 'entity/user/userHooks';
import { useRouter } from 'next/router';
import TierColorContainer from 'components/reward/TierColorContainer';
import EnrolledUserDashboard from '../../RewardsContent/RewardCreditCard/EnrolledUserDashboard';
import NonEnrolledUserDashboard from '../../RewardsContent/RewardCreditCard/NonEnrolledUserDashboard';

const ProfileEnrollCard = () => {
  const profile = useSelector(getProfileToDisplay);
  const tier = profile?.tier || 1;
  const isUserEnrolled = useIsEnrolledUser();
  const router = useRouter();

  return (
    <TierColorContainer className="rounded-lg h-fit w-full p-4" tier={tier}>
      {isUserEnrolled ? (
        <EnrolledUserDashboard
          onClick={() => {
            router.push('/rewards');
          }}
        />
      ) : (
        <NonEnrolledUserDashboard isInverted />
      )}
    </TierColorContainer>
  );
};

export default ProfileEnrollCard;
